import React from 'react';
import DenyDocumentModal from '../Dashboard/Company/Employees/Modal/DenyDocumentModal';
import ApproveDocumentModal from '../Dashboard/Company/Employees/Modal/ApproveDocumentModal';
import DocumentAppTable from '../Dashboard/Company/Employees/Table/DocumentAppTable';
import CustomTable from '../../components/table/CustomTable';
import DocumentTableApp from '../Dashboard/Company/Employees/Functionality/DocumentTableApp';

const DocumentTable = ({
    dataTable,
    approve,
    docValue,
    updated,
    setUpdated,
    modelVehicle='',
    withoutHeight=false,
    tableId ="tbl_dat_table",
    disabled=false,
    elementName='',
}) => {

    const {showModalApprove, setShowModalApprove, documentIdForApprove, documentPathForApprove, fullName,
        showModalDeny, setShowModalDeny, documentIdForDeny, documentPathForDeny,
        docType,userType,employee, handleDenyDocument, handleApproveDocument } = DocumentTableApp({dataTable, approve});

    const {thead, tbody, getActionsButtons} = DocumentAppTable({
        data: dataTable,
        setSelectedList: ()=>{},
        docValue,
        docType,
        userType,
        employee,
        handleDenyDocument,
        handleApproveDocument,
        tableId,
        disabled,
    });

    return (
        <>
            <CustomTable
                tableId={tableId}
                checkbox={false}
                checkboxTitle={"de_/_select_all"}
                checkboxFixed={false}
                isAllChecked={false}
                thead={thead}
                tbody={tbody}
                columnActions={true}
                getActionsButtons={getActionsButtons}
                withoutHeight={withoutHeight}
            />

            <ApproveDocumentModal
                modelVehicle={modelVehicle}
                show={showModalApprove}
                onHide={() => setShowModalApprove(false)}
                userType={userType}
                userName={employee?.name}
                documentId={documentIdForApprove}
                documentName={documentPathForApprove || ''}
                employeeName={fullName}
                updated={updated}
                setUpdated={setUpdated}
                itemName={elementName}
            />
            <DenyDocumentModal
                modelVehicle={modelVehicle}
                show={showModalDeny}
                onHide={() => setShowModalDeny(false)}
                userType={userType}
                userName={employee?.name}
                documentId={documentIdForDeny}
                documentName={documentPathForDeny || ''}
                employeeName={fullName}
                updated={updated}
                setUpdated={setUpdated}
                itemName={elementName}
            />
        </>
    );
};

export default DocumentTable;
